import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import theme from '@/config/theme';

const HelpFallback = () => (
  <View style={styles.container}>
    <Text style={styles.title}>Ajuda</Text>
    <Text style={styles.description}>
      Utilize o botão Ajuda no menu inferior ou na barra lateral para falar com nossa equipe pelo WhatsApp.
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing.lg,
    backgroundColor: theme.colors.background.secondary,
  },
  title: {
    fontSize: theme.fontSizes.xl,
    fontWeight: theme.fontWeights.bold as any,
    color: theme.colors.text.primary,
    marginBottom: theme.spacing.sm,
  },
  description: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.text.secondary,
    textAlign: 'center',
    lineHeight: theme.fontSizes.lg,
  },
});

export default HelpFallback;
